import React, { useEffect } from "react";
import "./scrollUp.css";

const ScrollUp = () => {
  useEffect(() => {
    const onScroll = () => {
      const scrollup = document.querySelector(".scrollup");
      if (!scrollup) return;

      if (window.scrollY >= 560) {
        scrollup.classList.add("show-scroll");
      } else {
        scrollup.classList.remove("show-scroll");
      }
    };

    window.addEventListener("scroll", onScroll);
    onScroll();

    return () => {
      window.removeEventListener("scroll", onScroll);
    };
  }, []);

  return (
    <a href="/#home" className="scrollup">
      <i className="uil uil-arrow-up scrollup__icon"></i>
    </a>
  );
};

export default ScrollUp;
